// Cuántas entregas esperan revisión (para «Entregas por revisar (n)» en los menús).
// Solo consulta si el usuario es tutor o admin; se refresca cada 2 minutos con la
// pestaña a la vista y cuando la bandeja califica algo (evento 'entregas:cambio').
import { useEffect, useState } from 'react';
import { entregasService } from '../../services/api';

export const ROLES_REVISORES = ['admin', 'mentor', 'coordinador'];
export const esRevisor = (user) => !!user && (!!Number(user.es_tutor) || ROLES_REVISORES.includes(user.role));

const useEntregasPendientes = (user) => {
  const [n, setN] = useState(0);
  const activo = esRevisor(user);
  useEffect(() => {
    if (!activo) { setN(0); return undefined; }
    let vivo = true;
    const cargar = () => {
      if (document.hidden) return;
      entregasService.resumen().then(r => { if (vivo) setN(r.data?.pendientes || 0); }).catch(() => {});
    };
    cargar();
    const t = setInterval(cargar, 120000);
    window.addEventListener('entregas:cambio', cargar);
    document.addEventListener('visibilitychange', cargar);
    return () => { vivo = false; clearInterval(t); window.removeEventListener('entregas:cambio', cargar); document.removeEventListener('visibilitychange', cargar); };
  }, [activo]);
  return { activo, pendientes: n };
};

export default useEntregasPendientes;

// Ítem de menú del tutor: texto editable en la ficha del proyecto (config_json.entregas.texto_menu).
export const esTutor = (user) => !!user && !!Number(user.es_tutor);
export const textoMenuEntregas = (proyecto, n) =>
  `${proyecto?.config_json?.entregas?.texto_menu || 'Entregas por revisar'}${n ? ` (${n})` : ''}`;
